export default "__VITE_ASSET__BAsvrvSw__"